module.exports = __webpack_public_path__ + "static/img/refresh.a55dd89.svg";